function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 3.75h-6c-.414 0-.75.336-.75.75v6c0 .414.336.75.75.75h6c.414 0 .75-.336.75-.75v-6c0-.414-.336-.75-.75-.75zM19.5 3.75h-6c-.414 0-.75.336-.75.75v6c0 .414.336.75.75.75h6c.414 0 .75-.336.75-.75v-6c0-.414-.336-.75-.75-.75zM10.5 12.75h-6c-.414 0-.75.336-.75.75v6c0 .414.336.75.75.75h6c.414 0 .75-.336.75-.75v-6c0-.414-.336-.75-.75-.75zM19.5 12.75h-6c-.414 0-.75.336-.75.75v6c0 .414.336.75.75.75h6c.414 0 .75-.336.75-.75v-6c0-.414-.336-.75-.75-.75z"
});

function SvgSquaresFour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquaresFour);
export default __webpack_public_path__ + "static/media/SquaresFour.1b6a0360.svg";
export { ForwardRef as ReactComponent };